export enum Locale {
  Da = "da",
  De = "de",
  En = "en",
  Es = "es",
  Fr = "fr",
  Hi = "hi",
  It = "it",
  Nl = "nl",
  Pl = "pl",
  Pt = "pt",
  Ro = "ro",
  Se = "se",
  Tr = "tr",
  Zh = "zh",
}
